import { render, staticRenderFns } from "./SubjectSet.vue?vue&type=template&id=a6f4d9a6&scoped=true&"
import script from "./SubjectSet.vue?vue&type=script&lang=js&"
export * from "./SubjectSet.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SubjectSet.vue?vue&type=style&index=1&id=a6f4d9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f4d9a6",
  null
  
)

export default component.exports